import { useIsInExperiment } from '../common';

export default function useIsInFeatureUpgradeExperiment() {
  return useIsInExperiment('vdp-features-tour-upgrade', 'experiment');
}
